__webpack_require__.p = "https://assets-ab.periodica.press/site-assets/";